"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AriForm_1 = require("../../../AriForm");
exports.default = [
    {
        key: 'labelPosition',
        ignore: true
    },
    {
        key: 'placeholder',
        ignore: true
    },
    {
        key: 'description',
        ignore: true
    },
    {
        key: 'hideLabel',
        ignore: true
    },
    {
        key: 'autofocus',
        ignore: true
    },
    {
        key: 'tableView',
        ignore: true
    },
    {
        key: 'label',
        hidden: true,
        calculateValue(context) {
            return context.data.legend;
        }
    },
    {
        weight: 1,
        type: 'textfield',
        input: true,
        key: 'legend',
        label: 'Legend',
        placeholder: 'Legend',
        tooltip: 'The legend for this Fieldset.'
    },
    {
        weight: 21,
        type: 'checkbox',
        label: 'Item direction row',
        tooltip: 'Item direction row',
        key: 'itemDirectionRow',
        input: true,
    },
    {
        weight: 21,
        type: 'checkbox',
        label: 'Is wrap items',
        tooltip: 'Is wrap items',
        key: 'isWrapItems',
        input: true,
    },
    {
        type: 'select',
        key: 'customClassName',
        label: 'Style Element',
        multiple: true,
        input: true,
        tooltip: 'select elemnt type for this html.',
        dataSrc: 'values',
        weight: 22,
        data: {
            values: [
                { label: 'Position fix', value: 'position-fixed' },
                { label: 'Backgound white', value: 'bg-white' },
                { label: 'Item Start', value: 'align-items-start' },
                { label: 'Item End', value: 'align-items-end' },
                { label: 'Justify content center', value: 'justify-content-center' },
                { label: 'Justify content between', value: 'justify-content-between' },
                { label: 'Justify content around', value: 'justify-content-around' },
                { label: 'Justify content start', value: 'custom-text-line-through' },
                { label: 'Justify content end', value: 'justify-content-end' },
            ],
        },
    },
    {
        weight: 25,
        type: 'checkbox',
        label: 'Set width element',
        tooltip: 'Set width element',
        key: 'setWitdhElement',
        input: true,
    },
    {
        weight: 26,
        type: 'textfield',
        input: true,
        key: 'waperWidth',
        label: 'Width of element',
        placeholder: '200px',
        tooltip: 'Set width of element, can use px,%,em,rem',
        conditional: {
            json: { '===': [{ var: 'data.setWitdhElement' }, true] },
        },
    },
    {
        weight: 24,
        type: 'checkbox',
        label: 'Set center element',
        tooltip: 'Set center element',
        key: 'setCenterElement',
        input: true,
        conditional: {
            json: { '===': [{ var: 'data.setWitdhElement' }, true] },
        },
    },
    {
        weight: 23,
        type: 'textfield',
        input: true,
        key: 'gapItem',
        label: 'Spacing Between Items',
        placeholder: `${AriForm_1.AriForm.tailwindPrefix}gap-0 or ${AriForm_1.AriForm.tailwindPrefix}gap-[2px]`,
        tooltip: 'Adjust the spacing between rows and columns.'
    },
    {
        weight: 27,
        type: 'checkbox',
        label: 'Set Spacing element',
        tooltip: 'Set Spacing element',
        key: 'setSpacingElement',
        input: true,
    },
    {
        weight: 28,
        type: 'textfield',
        input: true,
        key: 'paddingLeft',
        label: 'Spacing Left',
        placeholder: '0px',
        tooltip: 'Spacing Left can use px,%,em,rem',
        conditional: {
            json: { '===': [{ var: 'data.setSpacingElement' }, true] },
        },
    },
    {
        weight: 29,
        type: 'textfield',
        input: true,
        key: 'paddingRight',
        label: 'Spacing Right',
        placeholder: '0px',
        tooltip: 'Spacing Right can use px,%,em,rem',
        conditional: {
            json: { '===': [{ var: 'data.setSpacingElement' }, true] },
        },
    },
    {
        weight: 30,
        type: 'textfield',
        input: true,
        key: 'marginTop',
        label: 'Spacing Top',
        placeholder: '0px',
        tooltip: 'Spacing Top can use px,%,em,rem',
        conditional: {
            json: { '===': [{ var: 'data.setSpacingElement' }, true] },
        },
    },
    {
        weight: 31,
        type: 'textfield',
        input: true,
        key: 'marginBottom',
        label: 'Spacing Bottom',
        placeholder: '0px',
        tooltip: 'Spacing Bottom can use px,%,em,rem',
        conditional: {
            json: { '===': [{ var: 'data.setSpacingElement' }, true] },
        },
    },
];
